import { useContext, useRef } from 'react';
import Cta from '../cta/Cta';
import AnimateSplitLines from '../split-text/AnimateSplitLines';
import { motion, scale, useInView } from 'motion/react';
import { ComponentInViewContext } from '../component-wrapper/ComponentWrapper';

import {
  CUSTOM_EASE,
  calculateDelay,
  REVEAL_MARGIN,
} from '../../utils/animations';

export default function ComponentHeading({
  heading,
  subheading,
  firstBlock = false,
  cta,
}) {
  const HeadingTag = firstBlock ? 'h1' : 'h2';

  // Defers to the surrounding ComponentWrapper's in-view state (so the hr and
  // split text reveal in sync with sibling content); falls back to observing
  // itself when used without a wrapper ancestor.
  const innerRef = useRef(null);
  const contextInView = useContext(ComponentInViewContext);
  const selfInView = useInView(innerRef, {
    once: true,
    margin: REVEAL_MARGIN,
  });
  const isInView = contextInView ?? selfInView;

  const expand = {
    hidden: {
      opacity: 0.5,
      scaleX: 0,
      transformOrigin: 'left',
    },
    visible: {
      opacity: 1,
      scaleX: 1,
      transition: {
        delay: calculateDelay(2, 0),
        duration: 1,
        ease: CUSTOM_EASE,
      },
    },
  };

  return (
    <div className="l-grid__col ComponentHeading">
      <div className="ComponentHeading-inner" ref={innerRef}>
        {!heading && (
          <motion.hr
            variants={expand}
            initial="hidden"
            animate={isInView ? 'visible' : 'hidden'}
          />
        )}
        {subheading && (
          <p
            className="ComponentHeading-subheading headingStrong"
            style={{ maxWidth: '78ch' }}
          >
            <AnimateSplitLines
              html={subheading}
              inView={isInView}
              animationOrder={1}
            />
          </p>
        )}
        {heading && (
          <div className="ComponentHeading-text">
            <HeadingTag className={'h2'} style={{ maxWidth: '19ch' }}>
              <AnimateSplitLines html={heading} inView={isInView} />
            </HeadingTag>
            {cta && <Cta cta={cta} />}
          </div>
        )}
        {heading && (
          <motion.hr
            variants={expand}
            initial="hidden"
            animate={isInView ? 'visible' : 'hidden'}
          />
        )}
      </div>
    </div>
  );
}
